<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <!-- contents -->
      <div class="modal_header">
        <h5>
          De-register Machine
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="comment_wrap">
          <p>After de-registering you won't be able to use web client on this machine.</p>
        </div>
        <div class="form_wrap">
          <div class="fx_form_wrap detail_style">
            <div class="form_row">
              <div class="form_item inline_type">
                <label class="ctitle">One Time Key<span class="required">*</span></label>
                <div class="fx_form">
                  <input type="text" v-model="oneTimeKey" ref="oneTimeKey" placeholder="Enter One Time Key Code *">
                  <button type="button" class="btn btn-secondary" @click="onClickSendOneTimeKey" v-authorization="'EXECUTE'">
                  {{ $t('Re-Generate Key') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.close') }}
        </button>
        <button type="button"
          class="btn btn-primary"
          :class="{ 'btn-disabled': isKeyEmpty }"
          data-dismiss="modal"
          :disabled="isKeyEmpty"
          @click="onClickDeregisterMachine"
          v-authorization="'UPDATE'">
          {{ $t('De-register Machine') }}
        </button>
      </div>
      <!-- // contents -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {deRegisterMachine, sendOneTimeKey} from '@/service/webClientService';
import constants from "@/constants";
import {SDLUtil} from "@/utils";
import router from "@/router";

export default {
  data() {
    return {
      oneTimeKey: '',
      deregisterSuccessMessage: SDLUtil.getMsgProp('cop.webclient.machine.deregister.success'),
      deregisterErrorMessage: SDLUtil.getMsgProp('cop.webclient.machine.deregister.error'),
      oneTimeKeyRequiredMessage: SDLUtil.getMsgProp('cop.webclient.machine.oneTimeKey.required'),
      oneTimeKeySendSuccessMessage: SDLUtil.getMsgProp('cop.webclient.machine.oneTimeKey.success'),
      oneTimeKeySendErrorMessage: SDLUtil.getMsgProp('cop.webclient.machine.oneTimeKey.error'),

      updatable: false,
      executable: false,
    };
  },
  computed: {
    _() {
      return _;
    },
    isKeyEmpty() {
      return _.isEmpty(this.oneTimeKey);
    },
  },
  methods: {
    onClickSendOneTimeKey() {
      if (!this.executable) {
        SDLUtil.alert(this.$t('cop.authorization-lack.notice', ['EXECUTE']));
        return;
      }

      const thisVue = this;
      sendOneTimeKey().then(function(data) {
        if(data.status == 0 && data.error_code == 0) {
          thisVue.openSuccessToast(thisVue.oneTimeKeySendSuccessMessage);
        } else {
          thisVue.openErrorToast(thisVue.oneTimeKeySendErrorMessage);
        }
      });
    },
    onClickDeregisterMachine() {
      if (!this.updatable) {
        SDLUtil.alert(this.$t('cop.authorization-lack.notice', ['UPDATE']));
        return;
      }

      const thisVue = this;
      if(this.oneTimeKey == undefined || this.oneTimeKey == '' || this.oneTimeKey.length > constants.ONETIMEKEY_LENGTH) {
        thisVue.openWarningToast(thisVue.oneTimeKeyRequiredMessage);
        thisVue.$refs.oneTimeKey.focus();
      } else {
        deRegisterMachine(this.oneTimeKey).then(function (data) {
          if(data.status == 0 && data.error_code ==0) {
            thisVue.openSuccessToast(thisVue.deregisterSuccessMessage);
            thisVue.$emit('close');
            router.go(0);
          } else {
            thisVue.openErrorToast(thisVue.deregisterErrorMessage);
          }
        });
      }
    },
  },
  created() {
    const menuAuth = this.$route.meta.menuUserAuthList;
    if (menuAuth) {
      for (let i = 0; i < menuAuth.length; i++) {
        if (menuAuth[i] === 'UPDATE') this.updatable = true;
        if (menuAuth[i] === 'EXECUTE') this.executable = true;
      }
    }
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/web-client/popup/DeRegisterMachinePopup.vue